import {
  DefaultCustomLayoutDrawerProps,
  Drawer,
} from 'module/ui/components/atoms/drawer';
import { FC, useMemo } from 'react';
import { AddWebsite, AddWebsitePayload } from './add-website';

interface Props {
  open: boolean;
  apiDocVersion: boolean;
  folderName: string;
  onClose: () => void;
  onDone: (payload: AddWebsitePayload) => Promise<void>;
}
export const AddWebsiteDrawer: FC<Props> = ({
  open,
  apiDocVersion,
  onClose,
  onDone,
  folderName,
}) => {
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: folderName,
        link: '',
      },
    ];
  }, [folderName]);

  return (
    <Drawer
      width="672px"
      open={open}
      onClose={onClose}
      {...DefaultCustomLayoutDrawerProps}
    >
      <AddWebsite
        apiDocVersion={apiDocVersion}
        onClose={onClose}
        onDone={onDone}
        breadcrumbs={breadcrumbs}
      />
    </Drawer>
  );
};
